import type { Locale } from '@/enums/localeEnum'
import { LocaleEnum } from '@/enums/localeEnum'

class MixDefaultNamesService {
  allNames(locale: Locale) {
    switch (locale) {
      case 'cs': {
        return [
          'Mixit jak se patří',
          'Můj MIXIT',
          'Mixíček',
          'Dobrý Mix',
          'Mix jak má být',
          'Jenom můj Mix',
          'Namixuj si',
          'Parádní mix',
          'Tubus jak se patří',
          'Tubus jak má být',
          'Extra mix',
          'Extra Mixit',
          'Extrovní mix',
          'Extrovní Mixit',
          'Suprový mix',
          'Suprový tubus',
          'Fešácký mix',
          'Dobrůtka',
          'Mňamka',
          'Mňamózní mix',
          'Mňamózní tubus',
          'Mňamózní Mixit',
          'Mňam mix',
          'Mňam Mixit',
          'Mňam tubus',
          'Tubus plný dobrot',
          'Tubus plný Mixit',
          'Mix-it',
          'Vás mix',
          'Mixologie',
          'Just MIX IT',
          'Namixovano',
          'NaMIXITováno',
          'Mixer',
          'Remix',
          'Maximix',
          'Můj mix',
          'Náš mix',
          'Müsli mix',
          'Mixit',
          'Můj MIXIT',
          'Váš MixIT',
          'MIXIT',
          'Mix.IT',
          'Super Mix',
          '♥ Mixit ♥',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          '☺ MixIT ☺',
          '☻ MixIT ☻',
          'Mixit na míru',
          'Mixitmanie',
          'Dnešní Mix',
          'Velký Mix',
          'Povedený Mix',
          'Libový Mix',
          'Férový Mix',
          'Dobrý MIX',
          'MIX MIX',
          'Mixík',
          'Mixitík',
          'Mixmix',
          'Jedinečný Mixit',
          'Mixit je jen jeden',
          'Mixit do pohody',
          'SuperMix',
          'Dobrý Mix',
          'Chutný Mix',
          'Plný Tubus',
          'Plný tubus Mixit',
          'Můj dobrý Mix',
          'Jen Mixuj!',
          'Namixováno!',
          'www.mixit.cz',
          'www.mix.it',
          'Mix müsli',
          'Mixíčko',
          'I♥MIXIT',
        ]
      }
      case 'sk': {
        return [
          'Mixit ako sa patrí',
          'Môj MIXIT',
          'Mixíček',
          'Dobrý Mix',
          'Mix ako má byť',
          'Iba môj Mix',
          'Namixuj si',
          'Parádny mix',
          'Tubus ako sa patrí',
          'Tubus ako má byť',
          'Extra mix',
          'Extra Mixit',
          'Super mix',
          'Super tubus',
          'Fešácky mix',
          'Dobrôtka',
          'Mňamka',
          'Mňamózny mix',
          'Mňamózny tubus',
          'Mňamózny Mixit',
          'Mňam mix',
          'Mňam Mixit',
          'Mňam tubus',
          'Tubus plný dobrôt',
          'Tubus plný Mixit',
          'Mix-it',
          'Váš mix',
          'Mixológia',
          'Just MIX IT',
          'Namixované',
          'NaMIXITované',
          'Mixer',
          'Remix',
          'Maximix',
          'Môj mix',
          'Náš mix',
          'Müsli mix',
          'Mixit',
          'Môj MIXIT',
          'Váš MixIT',
          'MIXIT',
          'Mix.IT',
          'Super Mix',
          '♥ Mixit ♥',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          '☺ MixIT ☺',
          '☻ MixIT ☻',
          'Mixit na mieru',
          'Mixitmánia',
          'Dnešný Mix',
          'Velký Mix',
          'Podarený Mix',
          'Férový Mix',
          'Dobrý MIX',
          'MIX MIX',
          'Mixík',
          'Mixmix',
          'Jedinečný Mixit',
          'Mixit je len jeden',
          'Mixit do pohody',
          'SuperMix',
          'Dobrý Mix',
          'Chutný Mix',
          'Plný Tubus',
          'Plný tubus Mixit',
          'Môj dobrý Mix',
          'Mixuj!',
          'Namixovené!',
          'www.mixit.sk',
          'www.mix.it',
          'Mix müsli',
          'Mixíček',
          'I♥MIXIT',
        ]
      }
      case 'pl': {
        return [
          'Mixit jak powinien',
          'Mój MIXIT',
          'Mieszaneczka',
          'Pyszny mix',
          'Mix jak powinien być',
          'Tylko mój Mix',
          'Skomponuj',
          'Wspaniała mieszanka',
          'Tuba z prawdziwego zdarzenia',
          'Tuba jak powinna wyglądać',
          'Ekstra mix',
          'Ale ekstra Mixit',
          'Ekstra-bombastyczny-super mix',
          'Ekstra Mixit',
          'Wykwintna mieszanka',
          'Gustowna tuba',
          'Cacy mieszanka',
          'Pysznotka',
          'Ale pycha',
          'Wystrzałowa mieszanka',
          'Nieskazitelna tuba',
          'Smakołykowaty Mixit',
          'Pycha mix',
          'Przekąska Mixit',
          'Wykwintna tuba',
          'Tuba pełna smakołyków',
          'Tuba pełna Mixit',
          'Mix-it',
          'Twoja mieszanka',
          'Mixologia',
          'Just MIX IT',
          'Namieszane',
          'Apetyczny MIXIT',
          'Mixer',
          'Remix',
          'Maximix',
          'Mój mix',
          'Nasz mix',
          'Musli mix',
          'Mixit',
          'Mój MIXIT',
          'Twój MixIT',
          'MIXIT',
          'Mix.IT',
          'Super Mieszanka',
          '♥ Mixit ♥',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          '☺ MixIT ☺',
          '☻ MixIT ☻',
          'Mixit marzeń',
          'Mixitmania',
          'Dzisiejszy Mix',
          'Duża Mieszanka',
          'Udany Mix',
          'Dowolny Mix',
          'Prawdziwy Mix',
          'Kapitalny MIX',
          'MIX MIX',
          'Mixuś',
          'Mixmix',
          'Unikalny Mixit',
          'Mixit jest tylko jeden',
          'I♥MIXIT',
          'SuperMieszanka',
          'Nadprzeciętny Mix',
          'Smaczny Mix',
          'Pełna Tuba',
          'Tuba zapełniona Mixit',
          'Moja dobra Mieszanka',
          'Tylko komponuj!',
          'Skomponowane!',
          'www.mixit.pl',
          'www.mix.it',
          'Mieszanka musli',
          'Mixowata',
        ]
      }
      case 'hu': {
        return [
          'Mixit, ahogy azt kell',
          'Saját Mixit',
          'Mix',
          'Jó Mix',
          'Csak az én Mixem',
          'Keverd ki magad',
          'Egy parádés mix',
          'Egy rendes doboznyi mix',
          'Egy rendes doboznyi',
          'Egy csudajó mix',
          'Egy csudijó mix',
          'Extra jó mix',
          'Extra jó Mixit',
          'Szuper mix',
          'Szuper doboz mix',
          'Szép adag mix',
          'Finomság',
          'Finomságos mix',
          'Mennyei mix',
          'Egy doboznyi finomság',
          'Egy doboznyi finom Mixit',
          'NyaMIX',
          'Mixit finomságokkal teli doboz',
          'Finomsággal teli doboz',
          'Egy teli doboz Mixit',
          'Egy teli Mixittel teli doboz',
          'Saját Mixed',
          'Mixológia',
          'Just MIX IT',
          'Kimixitelve',
          'KiMIXITelve',
          'Mixer',
          'Remix',
          'Maximix',
          'Saját mixem',
          'Saját mixünk',
          'Müzli mix',
          'Mixit',
          'Saját MIXEM',
          'Saját Mixetek',
          'MIXIT',
          'Mix.IT',
          'Szuper Mix',
          '♥ Mixit ♥',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          '☺ MixIT ☺',
          '☻ MixIT ☻',
          'Személyre szabott Mixit',
          'Mixitmánia',
          'Mai Mix',
          'Nagy Mix',
          'Jól sikerült Mix',
          'Sovány Mix',
          'Fair Mix',
          'Finom MIX',
          'MIX MIX',
          'Egy kis Mix',
          'Mixecske',
          'Mixmix',
          'Egyedülálló Mixit',
          'Mixit csak egy van',
          'Nyugodtság Mix',
          'SzuperMix',
          'Finom Mix',
          'Ízletes Mix',
          'Teli doboz',
          'Mixittel teli doboz',
          'Saját jóféle Mix',
          'Csak Mixelj!',
          'Kikeverve!',
          'www.mixit.hu',
          'Müzli mix',
          'Jóféle mix',
          'I♥MIXIT',
        ]
      }
      case 'ro': {
        return [
          'Mixit la fix',
          'MIXIT',
          'Mixițel',
          'Mix bun',
          'Mix mișto',
          'Mix doar al meu',
          'Amestecă tu',
          'Mix de lux',
          'Cutia tare',
          'Cutia ideală',
          'Mix unic',
          'Mix de excepție',
          'Mix inedit',
          'Super Mixit',
          'Super mix',
          'Super cutie',
          'Mix tare',
          'Bunătate',
          'Deliciu',
          'Mix gustos',
          'Cutia mișto',
          'Mixit gustos',
          'Mix gustos',
          'Mixit delicios',
          'Cutia delicioasă',
          'Cutia plină de bunătăți',
          'Cutia plină cu Mixit',
          'Mix-it',
          'Mix-ul tău',
          'Mixologie',
          'Just MIX IT',
          'Amestecat',
          'Amestecat',
          'Mixer',
          'Remix',
          'Megamix',
          'Mix-ul meu',
          'Mix-ul nostru',
          'Musli mix',
          'Mixit',
          'MIXIT-ul meu',
          'MixIT pentru tine',
          'MIXIT',
          'Mix.IT',
          'Super Mix',
          '♥ Mixit ♥',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          '☺ MixIT ☺',
          '☻ MixIT ☻',
          'Mixit personalizat',
          'Mixitmania',
          'Mix-ul de azi',
          'Mix-ul mare',
          'Mix-ul reușit',
          'Mix-ul stilat',
          'Mix-ul fair',
          'MIX-ul bun',
          'MIX MIX',
          'Mixit',
          'Mixit',
          'Mixmix',
          'Mixit-ul unic',
          'Mixit e doar unul',
          'Mixit de relaxare',
          'SuperMix',
          'Mix-ul bun',
          'Mix-ul gustos',
          'Cutia plină',
          'Cutia plină Mixit',
          'Mix-ul meu bun',
          'Amestecă!',
          'Amestecat!',
          'mixit.cz',
          'mix.it',
          'Mix müsli',
          'Mixițel',
          'I♥MIXIT',
        ]
      }
      case 'de': {
        return [
          'Mein MIXIT',
          'Ein kleiner Mix',
          'Der gute Mix',
          'Ein Mix, wie er sein soll',
          'Nur mein Mix',
          'Mix Dir',
          'Supermix',
          'Eine Dose, wie sie sein soll',
          'Eine Dose, wie sie sein soll',
          'Extramix',
          'Extra Mixit',
          'Ein wunderbarer Mix',
          'Dein wunderbarer Mix',
          'Supermix',
          'Superdose',
          'Hipper Mix',
          'Leckerei',
          'Mhm lecker',
          'Lecker Mix',
          'Dose voller Leckereien',
          'Lecker Mixit',
          'Mhm Mix',
          'Mhm Mixit',
          'Mhm Dose',
          'Eine Dose voller Goodies',
          'Eine Doser voller Mixit',
          'Mix-it',
          'Dein Mix',
          'Mixologie',
          'Just MIX IT',
          'Gemixt',
          'GeMixit',
          'Mixer',
          'Remix',
          'Maximix',
          'Mein Mix',
          'Unser Mix',
          'Müsli mix',
          'Mixit',
          'Mein MIXIT',
          'Dein MIXIT',
          'MIXIT',
          'Mix.IT',
          'Super Mix',
          '♥ Mixit ♥',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          '☺ MixIT ☺',
          '☻ MixIT ☻',
          'Mixit maßgeschneidert',
          'Mixitmanie',
          'Heutiger Mix',
          'Großer Mix',
          'Ein gelungener Mix',
          'Edler Mix',
          'Ein fairer Mix',
          'Ein guter MIX',
          'MIX MIX',
          'Mixchen',
          'Mixitie',
          'Mixmix',
          'Ein einzigartiger Mix',
          'Mixit gibt es nur einmal',
          'Mixit zum Wohlfühlen',
          'SuperMix',
          'Ein guter Mix',
          'Ein schmackhafter  Mix',
          'Ein voller Mix',
          'Eine volle Dose Mixit',
          'Mein guter Mix',
          'Mixe nur!',
          'Fertig gemixt!',
          'www.mixit.de',
          'www.mix.it',
          'Mix Müsli',
          'Mixchen',
          'I♥MIXIT',
        ]
      } 
      case 'fr': {
        return [
          'Mixit comme il se doit',
          'Mon MIXIT',
          'Mixitou',
          'Bon Mix',
          'Mix comme il faut',
          'Rien qu’à moi',
          'Mixe-le',
          'Mix parfait',
          'Tubus comme il se doit',
          'Tubus comme il faut',
          'Mix extra',
          'Extra Mixit',
          'Mix d’exception',
          'Mixit d’exception',
          'Super mix',
          'Super tubus',
          'Mix chic',
          'Gourmandise',
          'Délice',
          'Mix délicieux',
          'Tubus délicieux',
          'Mixit délicieux',
          'Mix miam',
          'Miam Mixit',
          'Tubus miam',
          'Tubus plein de délices',
          'Tubus plein de Mixit',
          'Mix-it',
          'Votre mix',
          'Mixologie',
          'Just MIX IT',
          'Mélangé',
          'MixITé à fond',
          'Mixeur',
          'Remix',
          'Maximix',
          'Mon mix',
          'Notre mix',
          'Muesli mix',
          'Mixit',
          'Mon MIXIT',
          'Votre MixIT',
          'MIXIT',
          'Mix.IT',
          'Super Mix',
          ':hearts: Mixit :hearts:',
          '░▒▓ MIXIT ▓▒░',
          'MIX☼IT',
          '♪♫ MIXIT ♫♪',
          ':relaxed: MixIT :relaxed:',
          '☻ MixIT ☻',
          'Mixit sur mesure',
          'Mixitmania',
          'Mix du jour',
          'Grand Mix',
          'Mix réussi',
          'Mix top',
          'Mix honnête',
          'Bon MIX',
          'MIX MIX',
          'Mixik',
          'Mixitik',
          'Mixmix',
          'Mixit unique',
          'Mixit, l’unique',
          'Mixit pour la bonne humeur',
          'SuperMix',
          'Bon Mix',
          'Mix savoureux',
          'Tubus plein',
          'Tubus plein de Mixit',
          'Mon bon Mix',
          'Juste Mixe !',
          'Mélangé !',
          'www.mixit.cz',
          'www.mix.it',
          'Mix muesli',
        ]
      }
      default: {
        return []
      }
    }
  }

  randomName(locale: Locale) {
    const allNames = this.allNames(locale)
    return allNames[Math.floor(Math.random() * allNames.length)]
  }
}

export default new MixDefaultNamesService()
